import { FelaCSS } from '../../components/fela/flowtypes';
import { IStylingProps } from '../../themes/types';
import { TColor } from '../../types';
import IconWrap from './icon-wrap';

interface IProps extends IStylingProps {
  id?: string;
  color?: TColor;
  width?: number;
  style?: FelaCSS;
}

interface IconTypes {
  iconColor: string;
  width: number;
  height: number;
}

const viewBoxWidth = 16;
const viewBoxHeight = 16;

const Icon = ({ iconColor, width, height }: IconTypes) => (
  <svg
    viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
    width={`${width}px`}
    height={`${height}px`}
    fill="none">
    <rect
      x="2.6665"
      y="2.66675"
      width="10.6667"
      height="10.6667"
      rx="1.33333"
      stroke={iconColor}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.6665 5.33325H13.3332"
      stroke={iconColor}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M5.3335 2V2.66667" stroke={iconColor} strokeLinecap="round" strokeLinejoin="round" />
    <path d="M10.6665 2V2.66667" stroke={iconColor} strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M4.79004 7.83338C4.79004 7.69193 4.84623 7.55628 4.94625 7.45626C5.04627 7.35624 5.18192 7.30005 5.32337 7.30005H5.33004C5.47149 7.30005 5.60714 7.35624 5.70716 7.45626C5.80718 7.55628 5.86337 7.69193 5.86337 7.83338C5.86337 7.97483 5.80718 8.11049 5.70716 8.21051C5.60714 8.31053 5.47149 8.36672 5.33004 8.36672H5.32337C5.25333 8.36672 5.18398 8.35292 5.11927 8.32612C5.05457 8.29932 4.99577 8.26003 4.94625 8.21051C4.89672 8.16098 4.85744 8.10219 4.83064 8.03748C4.80383 7.97277 4.79004 7.90342 4.79004 7.83338ZM5.32337 9.96672C5.18192 9.96672 5.04627 10.0229 4.94625 10.1229C4.84623 10.2229 4.79004 10.3586 4.79004 10.5C4.79004 10.6415 4.84623 10.7772 4.94625 10.8772C5.04627 10.9772 5.18192 11.0334 5.32337 11.0334H5.33004C5.47149 11.0334 5.60714 10.9772 5.70716 10.8772C5.80718 10.7772 5.86337 10.6415 5.86337 10.5C5.86337 10.3586 5.80718 10.2229 5.70716 10.1229C5.60714 10.0229 5.47149 9.96672 5.33004 9.96672H5.32337ZM7.46337 7.83338C7.46337 7.69193 7.51956 7.55628 7.61958 7.45626C7.7196 7.35624 7.85526 7.30005 7.99671 7.30005H8.00337C8.14482 7.30005 8.28048 7.35624 8.3805 7.45626C8.48052 7.55628 8.53671 7.69193 8.53671 7.83338C8.53671 7.97483 8.48052 8.11049 8.3805 8.21051C8.28048 8.31053 8.14482 8.36672 8.00337 8.36672H7.99671C7.92667 8.36672 7.85731 8.35292 7.79261 8.32612C7.7279 8.29932 7.66911 8.26003 7.61958 8.21051C7.57006 8.16098 7.53077 8.10219 7.50397 8.03748C7.47717 7.97277 7.46337 7.90342 7.46337 7.83338ZM7.99671 9.96672C7.85526 9.96672 7.7196 10.0229 7.61958 10.1229C7.51956 10.2229 7.46337 10.3586 7.46337 10.5C7.46337 10.6415 7.51956 10.7772 7.61958 10.8772C7.7196 10.9772 7.85526 11.0334 7.99671 11.0334H8.00337C8.14482 11.0334 8.28048 10.9772 8.3805 10.8772C8.48052 10.7772 8.53671 10.6415 8.53671 10.5C8.53671 10.3586 8.48052 10.2229 8.3805 10.1229C8.28048 10.0229 8.14482 9.96672 8.00337 9.96672H7.99671ZM10.1367 7.83338C10.1367 7.69193 10.1929 7.55628 10.2929 7.45626C10.3929 7.35624 10.5286 7.30005 10.67 7.30005H10.6767C10.8182 7.30005 10.9538 7.35624 11.0538 7.45626C11.1538 7.55628 11.21 7.69193 11.21 7.83338C11.21 7.97483 11.1538 8.11049 11.0538 8.21051C10.9538 8.31053 10.8182 8.36672 10.6767 8.36672H10.67C10.6 8.36672 10.5306 8.35292 10.4659 8.32612C10.4012 8.29932 10.3424 8.26003 10.2929 8.21051C10.2434 8.16098 10.2041 8.10219 10.1773 8.03748C10.1505 7.97277 10.1367 7.90342 10.1367 7.83338ZM10.67 9.96672C10.5286 9.96672 10.3929 10.0229 10.2929 10.1229C10.1929 10.2229 10.1367 10.3586 10.1367 10.5C10.1367 10.6415 10.1929 10.7772 10.2929 10.8772C10.3929 10.9772 10.5286 11.0334 10.67 11.0334H10.6767C10.8182 11.0334 10.9538 10.9772 11.0538 10.8772C11.1538 10.7772 11.21 10.6415 11.21 10.5C11.21 10.3586 11.1538 10.2229 11.0538 10.1229C10.9538 10.0229 10.8182 9.96672 10.6767 9.96672H10.67Z"
      fill={iconColor}
    />
  </svg>
);

const IconCalendar = ({ width = 16, ...restProps }: IProps) => (
  <IconWrap
    icon={Icon}
    width={width}
    viewBoxWidth={viewBoxWidth}
    viewBoxHeight={viewBoxHeight}
    {...restProps}
  />
);

export default IconCalendar;
